




























import Component, { mixins } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import { PlanPayload } from '@/store/Mobile/state';

import formatter from '@/mixins/formatter';

import Price from '@/components/Atoms/Text/Price.vue';
import PlanInputArea from '@/components/Pages/MobileEstimate/Partial/PlanInputArea.vue';
import ListItem from '@/components/Atoms/ListItem/ListItemWithBorder.vue';

@Component({
  components: {
    ListItem,
    Price,
    PlanInputArea,
  },
})
export default class Plan extends mixins(formatter) {
  @Prop() private item!: any;
  @Prop() private namespace!: string;
  @Prop() private index!: number;
  @Prop() private simTypeId!: string;
  @Prop() planTotal!: number;
  @Prop() hasError?: boolean; // NOTE: planはliタグのスタイルをエラーのものにすることはない
  private carriers = ['docomo', 'au']; // TODO: 定義を持つ場所を決める
  countList = [0, 0];

  payload(carrier: string): PlanPayload {
    return {
      stateKey: 'plans',
      carrier: carrier,
      simType: this.simTypeId,
      id: this.item.id,
    };
  }

  get selected(): boolean {
    return this.total > 0;
  }

  get total() {
    return this.countList.reduce((z, n) => {
      return z + n;
    }, 0);
  }

  updateCount(args: { index: number; count: number }) {
    this.countList.splice(args.index, 1, args.count);
  }
}
